<template>
	<heading />
	<content class="">
		<div class="row">
			<div
				class="card custom-card bg-light col-xl-12 rounded-0 border-0 shadow"
			>
				<div class="row card-title pb-0 px-2 pt-2">
					<div class="row d-none">
						<div class="col-12 float-sm-left text-start">
							<h4 class="m-0 text-dark" style="font-family: NunitoBlack">
								<i class="nav-icon fas fa-users"></i>
								Agents, Tourists & Guides Management
							</h4>
						</div>
					</div>

					<div class="col-12">
						<div
							class="page-title-box d-sm-flex align-items-center justify-content-between nunito-black"
						>
							<div class="page-title-left">
								<ol class="breadcrumb m-0">
									<li class="breadcrumb-item">
										<a href="">
											<span
												class="badge rounded-pill bg-green-custom text-white font-size-15"
												>&nbsp;&nbsp;&nbsp;<i class="nav-icon fas fa-users"></i
												>&nbsp;&nbsp;Masters&nbsp;&nbsp;&nbsp;</span
											>
										</a>
									</li>

									<li class="active">
										&nbsp;&nbsp;Reservation Master&nbsp;&nbsp;
									</li>
								</ol>
							</div>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 pt-0">
					<!-- selected-class="bg-blue-custom text-white" -->
					<v-card>
						<v-tabs
							v-model="activeTab"
							density="compact"
							align-tabs="center"
							color="SteelBlue"
						>
							<v-tab :value="1">Agents</v-tab>
							<v-tab :value="2">Tourists</v-tab>
							<v-tab :value="3">Guides</v-tab>
						</v-tabs>

						<v-window v-model="activeTab">
							<v-window-item :value="1">
								<div class="card card-body accordion-body text-dark">
									<div class="row col-sm-12">
										<div class="col-sm-7 float-sm-left text-start"></div>
										<div
											class="col-sm-5 text-end"
											style="font-family: HeaderCustomFont"
										>
											<!-- @click="openModal(modal, data)" -->
											<button
												class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
												@click="openModal('agent')"
											>
												<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Add
												Agent
											</button>
										</div>
									</div>
									<div class="row col-sm-12 mt-2 m-1">
										<v-data-table
											:headers="agentHeaders"
											:items="agentsComputed"
											:items-per-page="agentPerPage"
											density="compact"
											item-value="name"
											class="table-sm table-striped rounded-0 table-responsive table-wrap"
										>
											<template v-slot:body="{ items }">
												<tr
													class="align-top"
													v-for="(item, index) in items"
													:key="item.id"
												>
													<td>{{ item.index }}</td>
													<td>{{ item.name }}</td>
													<td>{{ item.supplier_id }}</td>
													<td>{{ item.phone_number }}</td>
													<td>{{ item.email }}</td>
													<td>{{ item.country_id }}</td>
													<td class="">
														<v-menu offset-y>
															<template v-slot:activator="{ props }">
																<v-icon v-bind="props" size="24">
																	mdi-dots-horizontal
																</v-icon>
															</template>

															<v-list density="compact" class="custom-dropdown">
																<v-list-item
																	@click="manageAgents(item, 'edit')"
																>
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-regular fa-pen-to-square"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																	>
																</v-list-item>
																<v-list-item
																	@click="manageAgents(item, 'delete')"
																>
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-solid fa-trash"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																	>
																</v-list-item>
															</v-list>
														</v-menu>
													</td>
												</tr>
											</template>
										</v-data-table>
									</div>
								</div>
							</v-window-item>

							<v-window-item :value="2">
								<div class="card card-body accordion-body text-dark">
									<div class="row col-sm-12">
										<div class="col-sm-7 float-sm-left text-start"></div>
										<div
											class="col-sm-5 text-end"
											style="font-family: HeaderCustomFont"
										>
											<button
												class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
												@click="openModal('tourist')"
											>
												<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Add
												Tourist
											</button>
										</div>
									</div>
									<div class="row col-sm-12 mt-2 m-1">
										<v-data-table
											:headers="touristHeaders"
											:items="touristsComputed"
											:items-per-page="touristPerPage"
											density="compact"
											item-value="name"
											class="table-sm table-striped rounded-0 table-responsive table-wrap"
										>
											<template v-slot:body="{ items }">
												<tr
													class="align-top"
													v-for="(item, index) in items"
													:key="item.id"
												>
													<td>{{ item.index }}</td>
													<td>{{ item.name }}</td>
													<td>{{ item.country_id }}</td>
													<td>{{ item.dob }}</td>
													<td>{{ item.gender }}</td>
													<td>{{ item.passport_no }}</td>
													<td class="">
														<v-menu offset-y>
															<template v-slot:activator="{ props }">
																<v-icon v-bind="props" size="24">
																	mdi-dots-horizontal
																</v-icon>
															</template>

															<v-list density="compact" class="custom-dropdown">
																<v-list-item
																	@click="manageTourists(item, 'edit')"
																>
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-regular fa-pen-to-square"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																	>
																</v-list-item>
																<v-list-item
																	@click="manageTourists(item, 'delete')"
																>
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-solid fa-trash"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																	>
																</v-list-item>
															</v-list>
														</v-menu>
													</td>
												</tr>
											</template>
										</v-data-table>
									</div>
								</div>
							</v-window-item>

							<v-window-item :value="3">
								<div class="card card-body accordion-body text-dark">
									<div class="row col-sm-12">
										<div class="col-sm-7 float-sm-left text-start"></div>
										<div
											class="col-sm-5 text-end"
											style="font-family: HeaderCustomFont"
										>
											<button
												class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
												@click="openModal('guide')"
											>
												<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Add
												Guide
											</button>
										</div>
									</div>
									<div class="row col-sm-12 mt-2 m-1">
										<v-data-table
											:headers="guideHeaders"
											:items="guidesComputed"
											:items-per-page="guidePerPage"
											density="compact"
											item-value="name"
											class="table-sm table-striped rounded-0 table-responsive table-wrap"
										>
											<template v-slot:body="{ items }">
												<tr
													class="align-top"
													v-for="(item, index) in items"
													:key="item.id"
												>
													<td>{{ item.index }}</td>
													<td>{{ item.name }}</td>
													<td>{{ item.email }}</td>
													<td>{{ item.phone_number }}</td>
													<td>{{ item.languages }}</td>
													<td class="">
														<v-menu offset-y>
															<template v-slot:activator="{ props }">
																<v-icon v-bind="props" size="24">
																	mdi-dots-horizontal
																</v-icon>
															</template>

															<v-list density="compact" class="custom-dropdown">
																<v-list-item
																	@click="manageGuides(item, 'edit')"
																>
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-regular fa-pen-to-square"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																	>
																</v-list-item>
																<v-list-item
																	@click="manageGuides(item, 'delete')"
																>
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-solid fa-trash"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																	>
																</v-list-item>
															</v-list>
														</v-menu>
													</td>
												</tr>
											</template>
										</v-data-table>
									</div>
								</div>
							</v-window-item>
						</v-window>
					</v-card>
				</div>
			</div>

			<!-- Agent Modal -->
			<v-dialog v-model="agentModal" max-width="600px" persistent>
				<form
					@submit.prevent="
						editMode
							? manageAgents(null, 'update')
							: manageAgents(null, 'insert')
					"
				>
					<v-card>
						<v-card-title class="d-flex justify-space-between align-center">
							<span
								><div class="modal-header">
									<h5
										class="modal-title font-size-20 text-dark"
										style="font-family: HeaderCustomFont"
									>
										<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;{{
											editMode ? "Edit" : "Add"
										}}
										Agent
									</h5>
								</div></span
							>
							<v-icon @click="closeModal('agent')">mdi-close</v-icon>
						</v-card-title>
						<v-card-text>
							<div class="modal-body p-4">
								<div class="text-start"></div>
							</div>
						</v-card-text>
						<v-card-actions>
							<v-spacer>
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Agent
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('agent')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
						</v-card-actions>
					</v-card>
				</form>
			</v-dialog>

			<!-- Tourist Modal -->
			<v-dialog v-model="touristModal" max-width="600px" persistent>
				<form
					@submit.prevent="
						editMode
							? manageTourists(null, 'update')
							: manageTourists(null, 'insert')
					"
				>
					<v-card>
						<v-card-title class="d-flex justify-space-between align-center">
							<span
								><div class="modal-header">
									<h5
										class="modal-title font-size-20 text-dark"
										style="font-family: HeaderCustomFont"
									>
										<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;{{
											editMode ? "Edit" : "Add"
										}}
										Tourist
									</h5>
								</div></span
							>
							<v-icon @click="closeModal('tourist')">mdi-close</v-icon>
						</v-card-title>
						<v-card-text>
							<div class="modal-body p-4">
								<div class="text-start"></div>
							</div>
						</v-card-text>
						<v-card-actions>
							<v-spacer>
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Tourist
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('tourist')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
						</v-card-actions>
					</v-card>
				</form>
			</v-dialog>

			<!-- Guide Modal -->
			<v-dialog v-model="guideModal" max-width="600px" persistent>
				<form
					@submit.prevent="
						editMode
							? manageGuides(null, 'update')
							: manageGuides(null, 'insert')
					"
				>
					<v-card>
						<v-card-title class="d-flex justify-space-between align-center">
							<span
								><div class="modal-header">
									<h5
										class="modal-title font-size-20 text-dark"
										style="font-family: HeaderCustomFont"
									>
										<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;{{
											editMode ? "Edit" : "Add"
										}}
										Guide
									</h5>
								</div></span
							>
							<v-icon @click="closeModal('guide')">mdi-close</v-icon>
						</v-card-title>
						<v-card-text>
							<div class="modal-body p-4">
								<div class="text-start"></div>
							</div>
						</v-card-text>
						<v-card-actions>
							<v-spacer>
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Guide
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('guide')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
						</v-card-actions>
					</v-card>
				</form>
			</v-dialog>
		</div>
	</content>
</template>

<script>
import config from "../../config/settings.js";
import { Errors, Form } from "vform";

export default {
	name: "ReservationMaster",
	data() {
		return {
			api: config.API_URL,
			message: "",
			http_code: "",
			user: [],
			activeTab: "agents",

			agentModal: false,
			touristModal: false,
			guideModal: false,
			editMode: false,
			tourAgent: new Form({
				id: "",
				name: "",
				supplier_id: "",
				phone_number: "",
				email: "",
				country_id: "",
			}),
			tourTourist: new Form({
				id: "",
				name: "",
				country_id: null,
				dob: "",
				gender: "",
				passport_no: "",
			}),
			tourGuide: new Form({
				id: "",
				name: "",
				email: "",
				phone_number: "",
				languages: "",
			}),
			agentPerPage: 10,
			touristPerPage: 10,
			guidePerPage: 10,
			agents: [],
			agentHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Name", value: "name", sortable: true },
				{ title: "Supplier ID", value: "supplier_id", sortable: true },
				{ title: "Phone", value: "phone_number", sortable: true },
				{ title: "Email", value: "email", sortable: true },
				{ title: "Country ID", value: "country_id", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],
			tourists: [],
			touristHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Name", value: "name", sortable: true },
				{ title: "Country ID", value: "country_id", sortable: true },
				{ title: "DOB", value: "dob", sortable: true },
				{ title: "Gender", value: "gender", sortable: true },
				{ title: "Passport", value: "passport_no", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],
			guides: [],
			guideHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Name", value: "name", sortable: true },
				{ title: "Email", value: "email", sortable: true },
				{ title: "Phone", value: "phone_number", sortable: true },
				{ title: "Languages", value: "languages", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],
		};
	},
	methods: {
		async getUser() {
			var user_id = localStorage.getItem("user_id");
			if (user_id) {
				var api = this.api + "/user/" + user_id;
				const query = await this.getData(api);
				if (query.result == "success") {
					this.user = query.response;
				}
			}
		},
		openModal(modal) {
			this.editMode = false;
			if (modal == "agent") {
				this.agentModal = true;
				this.tourAgent.reset();
			} else if (modal == "tourist") {
				this.touristModal = true;
				this.tourTourist.reset();
			} else if (modal == "guide") {
				this.guideModal = true;
				this.tourGuide.reset();
			}
		},
		closeModal(modal) {
			if (modal == "agent") {
				this.agentModal = false;
				this.tourAgent.reset();
				this.tourAgent.errors.clear();
			} else if (modal == "tourist") {
				this.touristModal = false;
				this.tourTourist.reset();
				this.tourTourist.errors.clear();
			} else if (modal == "guide") {
				this.guideModal = false;
				this.tourGuide.reset();
				this.tourGuide.errors.clear();
			}
			this.editMode = false;
		},
		async getInfinites(mode) {},
		async manageAgents(event, mode) {
			var query, api;
			if (mode == "fetch") {
				api = `${this.api}/v1/masters/agents`;
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.agents = [];
					this.agents = query.response;
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "insert") {
				this.tourAgent.created_by = this.user.id;
				api = `${this.api}/v1/masters/agents`;
				query = await this.postData(api, this.tourAgent);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("agent");
					this.manageAgents(null, "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				this.tourAgent.updated_by = this.user.id;
				api = `${this.api}/v1/masters/agents/${this.tourAgent.id}`;
				query = await this.putData(api, this.tourAgent);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("agent");
					this.manageAgents(null, "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.tourAgent.reset();
				this.tourAgent.fill(event);
				this.editMode = true;
				this.openModal("agent");
			} else if (mode == "delete") {
				let confirmation = await this.showConfirmation("Delete this Agent?");
				if (confirmation.result == "Yes") {
					api = `${this.api}/v1/masters/agents/${event.id}`;
					query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.manageAgents(null, "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			}
		},
		async manageTourists(event, mode) {
			var query, api;
			if (mode == "fetch") {
				api = `${this.api}/v1/masters/tourist`;
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.tourists = [];
					this.tourists = query.response;
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "insert") {
				this.tourTourist.created_by = this.user.id;
				api = `${this.api}/v1/masters/tourist`;
				query = await this.postData(api, this.tourTourist);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("tourist");
					this.manageTourists(null, "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				this.tourTourist.updated_by = this.user.id;
				api = `${this.api}/v1/masters/tourist/${this.tourTourist.id}`;
				query = await this.putData(api, this.tourTourist);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("tourist");
					this.manageTourists(null, "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.tourTourist.reset();
				this.tourTourist.fill(event);
				this.editMode = true;
				this.openModal("tourist");
			} else if (mode == "delete") {
				let confirmation = await this.showConfirmation("Delete this Tourist?");
				if (confirmation.result == "Yes") {
					api = `${this.api}/v1/masters/tourist/${event.id}`;
					query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.manageTourists(null, "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			}
		},
		async manageGuides(event, mode) {
			var query, api;
			if (mode == "fetch") {
				api = `${this.api}/v1/masters/guides`;
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.guides = [];
					this.guides = query.response;
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "insert") {
				this.tourGuide.created_by = this.user.id;
				api = `${this.api}/v1/masters/guides`;
				query = await this.postData(api, this.tourGuide);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("guide");
					this.manageGuides(null, "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				this.tourGuide.updated_by = this.user.id;
				api = `${this.api}/v1/masters/guides/${this.tourGuide.id}`;
				query = await this.putData(api, this.tourGuide);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("guide");
					this.manageGuides(null, "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.tourGuide.reset();
				this.tourGuide.fill(event);
				this.editMode = true;
				this.openModal("guide");
			} else if (mode == "delete") {
				let confirmation = await this.showConfirmation("Delete this Guide?");
				if (confirmation.result == "Yes") {
					api = `${this.api}/v1/masters/guides/${event.id}`;
					query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.manageGuides(null, "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			}
		},
	},
	computed: {
		currentRoute() {
			return this.$route.path.includes("/masters/");
		},
		agentsComputed() {
			if (!Array.isArray(this.agents)) return [];
			return this.agents.map((agent, index) => {
				agent.index = index + 1;
				return agent;
			});
		},
		touristsComputed() {
			if (!Array.isArray(this.tourists)) return [];
			return this.tourists.map((tourist, index) => {
				tourist.index = index + 1;
				return tourist;
			});
		},
		guidesComputed() {
			if (!Array.isArray(this.guides)) return [];
			return this.guides.map((guide, index) => {
				guide.index = index + 1;
				return guide;
			});
		},
	},
	created() {
		this.getUser();
		this.manageAgents(null, "fetch");
		this.manageTourists(null, "fetch");
		this.manageGuides(null, "fetch");
	},
	beforeMount() {},
	mounted() {},
	unmounted() {},
	beforeUnmount() {},
};
</script>